<template>
  <el-row class="pet-container">
    <!-- 宠物本体 -->
    <div
      class="pet"
      :class="{ jump: isJumping, shake: isShaking }"
      @click="feedPet"
    >
      <div class="pet-body">
        <div class="ear left-ear"></div>
        <div class="ear right-ear"></div>
        <div class="face">
          <div class="eye left-eye"></div>
          <div class="eye right-eye"></div>
          <div class="mouth"></div>
        </div>
      </div>
    </div>

    <!-- 控制按钮 -->
    <el-row class="control-buttons">
      <el-button type="primary" @click="startJump" round>
        <i class="el-icon-top"></i> 跳跃
      </el-button>

      <el-button type="success" @click="startShake" round>
        <i class="el-icon-refresh"></i> 摇动
      </el-button>

      <el-button type="warning" @click="showMessage" round>
        <i class="el-icon-chat-dot-round"></i> 说话
      </el-button>
    </el-row>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      isJumping: false,
      isShaking: false,
    };
  },
  methods: {
    startJump() {
      this.isJumping = true;
      setTimeout(() => {
        this.isJumping = false;
      }, 1000);
    },
    startShake() {
      this.isShaking = true;
      setTimeout(() => {
        this.isShaking = false;
      }, 500);
    },
    feedPet() {
      this.$notify({
        title: "宠物说",
        message: "谢谢你喂我吃东西！🐟",
        type: "success",
      });
    },
    showMessage() {
      this.$message({
        message: "主人你好呀！今天天气真不错～",
        type: "info",
        showClose: true,
      });
    },
  },
};
</script>

<style scoped>
.pet-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
}

.pet {
  width: 150px;
  height: 150px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
}

.pet-body {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ffb6c1;
  border-radius: 50%;
}

.ear {
  position: absolute;
  width: 40px;
  height: 60px;
  background: #ffb6c1;
  border-radius: 20px;
}

.left-ear {
  left: -20px;
  transform: rotate(-30deg);
}

.right-ear {
  right: -20px;
  transform: rotate(30deg);
}

.face {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
}

.eye {
  width: 20px;
  height: 20px;
  background: #333;
  border-radius: 50%;
  position: absolute;
}

.left-eye {
  left: -30px;
}
.right-eye {
  right: -30px;
}

.mouth {
  width: 40px;
  height: 20px;
  border: 3px solid #333;
  border-radius: 0 0 40px 40px;
  border-top: 0;
  margin-top: 20px;
}

/* 动画效果 */
.jump {
  animation: jump 0.5s ease;
}

@keyframes jump {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-50px);
  }
}

.shake {
  animation: shake 0.3s ease-in-out infinite;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(5deg);
  }
  75% {
    transform: rotate(-5deg);
  }
}

.control-buttons {
  margin-top: 30px;
  gap: 20px;
}

.el-button {
  margin: 0 10px;
  padding: 12px 24px;
}
</style>
